module.exports = __webpack_public_path__ + "static/media/bx2.916f342b.jpg";